import { OfficeMissingInfoGate } from './OfficeMissingInfo/OfficeMissingInfoGate';
import { usePsaGate } from './PsaGate';

export const OfficeRequirementsGate = () => {
  const isTermsPopupBlocking = usePsaGate();

  return <OfficeMissingInfoGate isPaused={isTermsPopupBlocking} />;
};
